var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('MarqueeText',{staticClass:"title-project",attrs:{"repeat":6,"duration":10}},[_c('h2',[_vm._v("legendary layers ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }